import { token } from '@bynder/design-system';
import styled from 'styled-components';

export const Tooltip = styled.div`
    position: fixed;
    top: calc(${token.spacing5} * -1);
    right: ${token.spacing2};
    background: ${token.gray800};
    color: ${token.white};
    padding: ${token.spacing3};
    font-size: ${token.fontSize75};
    border-radius: 6px;
    display: none;
    box-shadow: ${token.elevation4};
`;

export const CloseButtonContainer = styled.div`
    position: relative;
    &:hover {
        cursor: pointer;

        ${Tooltip} {
            display: block;
        }
    }
`;

export const ContentWrapper = styled.div`
    max-width: 221px;
    word-wrap: break-word;
`;
